import { render } from "./MyContactList.vue?vue&type=template&id=cdd48aee&scoped=true"
import script from "./MyContactList.vue?vue&type=script&lang=js"
export * from "./MyContactList.vue?vue&type=script&lang=js"

import "./MyContactList.vue?vue&type=style&index=0&id=cdd48aee&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd48aee"]])

export default __exports__